/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { StationStreamDto } from "./StationStreamDto";

export const StationDtoTypeEnum = {
    STANDALONE: "STANDALONE",
    HEADER: "HEADER",
    REPEATER: "REPEATER",
    AFFILIATE: "AFFILIATE"
} as const;

export type StationDtoTypeEnumKey = (typeof StationDtoTypeEnum)[keyof typeof StationDtoTypeEnum];

export type StationDto = {
    /**
     * @description Station unique identifier
     * @type string
    */
    id: string;
    /**
     * @description Station name
     * @type string
    */
    name: string;
    /**
     * @description Station URL slug
     * @type string
    */
    slug: string;
    /**
     * @description Station type
     * @type string
    */
    type: StationDtoTypeEnumKey;
    /**
     * @description Station aliases
     * @type array
    */
    aliases: string[];
    /**
     * @description Stream format
     * @type string
    */
    format: string;
    /**
     * @description Station timezone
     * @type string
    */
    timezone: string;
    /**
     * @description Language code in BCP-47 format
     * @type string
    */
    language: string;
    /**
     * @description Data retention period in days
     * @type number | undefined
    */
    retentionDays?: number;
    /**
     * @description Data retention date (ISO 8601 format)
     * @type string | undefined
    */
    retentionDate?: string;
    /**
     * @description Station logo URL
     * @type string
    */
    logoUrl?: string | null;
    /**
     * @description Station streams
     * @type array | undefined
    */
    streams?: StationStreamDto[];
    /**
     * @description YouTube channel identifier
     * @type string
    */
    youtubeChannelId?: string | null;
    /**
     * @description Features configuration
     * @type object
    */
    featuresConfig: object | null;
};